import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { SearchForm } from "../SearchFormLegacy";
import { StageContentContainer, StageCaption } from "../StageLegacy/Stage.styles";
var AffiliateSearchForm = function(param) {
    var color = param.color;
    return /*#__PURE__*/ _jsx(StageContentContainer, {
        isAffiliate: true,
        children: /*#__PURE__*/ _jsx(StageCaption, {
            children: /*#__PURE__*/ _jsx(SearchForm, {
                isAffiliate: true,
                customColor: color
            })
        })
    });
};
export { AffiliateSearchForm };
